var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTezexIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 27,
    viewBox: "0 0 38 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.7534 23.9415C24.5363 23.9415 29.2242 19.2535 29.2242 13.4707C29.2242 7.6879 24.5363 3 18.7534 3C12.9706 3 8.28271 7.6879 8.28271 13.4707C8.28271 19.2535 12.9706 23.9415 18.7534 23.9415Z",
    stroke: "black",
    strokeWidth: 4.18829
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.4129 11.3766H2.09415C0.937581 11.3766 0 12.3142 0 13.4707C0 14.6273 0.937581 15.5649 2.09415 15.5649H35.4129C36.5695 15.5649 37.5071 14.6273 37.5071 13.4707C37.5071 12.3142 36.5695 11.3766 35.4129 11.3766Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTezexIcon);
export default __webpack_public_path__ + "static/media/tezexIcon.3c8afc012f361860a7d52d042c689e72.svg";
export { ForwardRef as ReactComponent };